import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { AmenityCategory } from "./amenity-category.model";

/**
 * @class DefaultPropertyAmenity
 * @property {number} id
 * @property {string} title
 * @property {AmenityCategory} category
 * @property {integer} status
 */
export class DefaultPropertyAmenity extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'title' ];
    }
    
    /**
     * @param {Object|AmenityCategory} value
     * @returns {AmenityCategory}
     */
    setAmenityCategory(value) {
        
        if (typeof value === 'undefined') {
            
            return value;
        }
        
        return value instanceof AmenityCategory ? value : new AmenityCategory(value);
    }
    
    static get validationModel() {
        
        return {
            title: {
                label: 'AMENITY_NAME_IN_ENGLISH',
                commonLabel: 'Amenity name'
            },
            title_ar: {
                label: 'AMENITY_NAME_IN_ARABIC',
                commonLabel: 'Amenity name'
            },
            category: {
                label: 'AMENITY_CATEGORY',
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...DefaultPropertyAmenity.translatableAttributesWithLanguageAliases, 'amenity_category', 'status')(DefaultPropertyAmenity);


// WEBPACK FOOTER //
// ./src/pms-api/models/default-property-amenity.model.js